import { render, staticRenderFns } from "./PolicyTab.vue?vue&type=template&id=2aeca5e6&"
import script from "./PolicyTab.vue?vue&type=script&lang=js&"
export * from "./PolicyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports